/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class PopOverDirective {
    public restrict = 'A';
    public scope;

    constructor() {
        this.scope = {
            onConfirm: '&'
        }
    }

    public link = (scope: any, element: any, attrs: any) => {
        $(element).popover({
            content: attrs.content,
            container: attrs.container || element,
            placement: attrs.placement || 'bottom',
            html: attrs.html === 'true'
        });

        $(element).on('click', '.popover-content .btn', function() {
            if($(this).hasClass('confirm')) scope.onConfirm();
        });
    };
    public static DirectiveFn(): PopOverDirective {
        return new PopOverDirective();
    }
}

angular.module('beneple.global').directive('popOver', PopOverDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/pop-over.directive.ts